import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Approach from "../components/Approach";
import PrimaryPractice from "../components/PrimaryPractice";
import Services from "../components/Services";
import Background from "../components/Background";
import Engagement from "../components/Engagement";
import Shipped from "../components/Shipped";
import Insights from "../components/Insights";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { useReveal } from "../hooks/useReveal";

export default function Landing() {
  useReveal();
  return (
    <div className="min-h-screen bg-paper text-ink" data-testid="landing-root">
      <Nav />
      <main>
        <Hero />
        <Approach />
        <PrimaryPractice />
        <Services />
        <Background />
        <Engagement />
        <Shipped />
        <Insights />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
